import React, { useEffect, useState, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import {BaseUrl} from "../../../contexts/baseUrl/baseUrl";

const ClientOrders = ({
    history,
    match,
    clientOrderListing,
    getClientOrdersListing = []
}) => {
  const headers = [
    "Site No.",
    "Client Name",
    "Project Id",
    "Order Date",
    "Amount",
    "Total GST Amount",
    "Total Amount",
    "View Details"
  ];

  const modalHeaders = ["Material Name", "Quantity", "Unit Price", "GST%", "GST Amount"]; 

  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();
  const [isModal, setIsModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null); 
  const {baseUrl} = useContext(BaseUrl);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await clientOrderListing();
      setIsLoading(false);
    })();
  }, [clientOrderListing]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await clientOrderListing(val.selected + 1);
    setIsLoading(false);
  };

  const mrfCreate = () => {
    history.push(`${baseUrl}/mrf`);
}

  const headerBtns = () => {
    return (
        <>      
        <Button
            onClick={mrfCreate}
            className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
        >
            <b className="site_filters" style={{width: "max-content"}}>
                {localization.materialAcquisition}
            </b>
        </Button>
{/* 
            <Fragment>
                <Button
                onClick={filterToggle}
                className="filter-hamburger btn btn-transparent"
                >
                <img src={Images?.Filter} alt=""></img>
                {localization.showFilters}
                </Button>
            </Fragment> */}
        </>
    );
};

  useEffect(() => {
    const tableData = [
      "site_no",
      "client_name",
      "project_id",
      "order_date",
      "amount",
      "gst_amount",
      "total_amount"
    ];

    if (getClientOrdersListing && getClientOrdersListing.data) {
      const data = getClientOrdersListing.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]: element[key] || "",
          })),
          {
            actions: (
              <button
                className="btn btn-link"
                onClick={() => handleViewDetails(element)}
              >
                View Details
              </button>
            ),
          }
        )
      );

      setListData(data.length > 0 ? data : []);
      setPageCount(
        Math.ceil(getClientOrdersListing.total / getClientOrdersListing.per_page)
      );
    }
  }, [getClientOrdersListing]);

  const handleViewDetails = (order) => {
    setSelectedOrder(order); // Set selected order for modal
    setIsModal(true); // Show modal
  };

  const handleModalHide = () => {
    setIsModal(false);
    setSelectedOrder(null); // Clear selected order when modal is closed
  };

  console.log("DATA: ", getClientOrdersListing);

  return (
    <Layout
      title={"Client Orders"}
      Buttons={headerBtns}
      isLoading={isLoading}
      isGoback
    >
      <TableSection
        data={listData}
        isId={true}
        headers={headers}
        pageCount={pageCount}
        srNo={getClientOrdersListing?.from}
        onPageChange={onPageChange}
      />
      {/* 
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        allValetListFilter
      /> */}

      <ModalPop
        title={"Material Details"}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="col-md-12">
          {selectedOrder?.items && selectedOrder.items.length > 0 ? (
            <TableSection
              data={selectedOrder.items.map((item) => ({
                material_name: item.material_name,
                quantity: item.quantity,
                unit_price: item.unit_price,
                gst_percent: item.gst_rate,
                gst_amount: item.gst_amount
              }))}
              isId={false}
              headers={modalHeaders}
            />
          ) : (
            <p>No items available for this order.</p>
          )}
        </div>
      </ModalPop>
    </Layout>
  );
};

export default ClientOrders;
